export default __webpack_public_path__ + "static/media/Oracle-WindowsTaskScheduler-Result09.beb1c525.png";